export default __webpack_public_path__ + "static/media/SamplePoster.8661c851.svg";